<template>
  <div class="employee-management">
    <div class="card-header inv-inout-card-header">
      <div class="card-title">出入库填报</div>
      <div class="inv-mgmt-excel-actions inv-inout-card-header__center">
        <el-button type="default" size="small" class="inv-mgmt-excel-btn" @click="openCreateItemDialog">
          添加库存商品
        </el-button>
        <el-upload
          class="el-upload el-upload--button inv-mgmt-upload"
          :show-file-list="false"
          :before-upload="handleImportExcel"
          accept=".xls,.xlsx"
        >
          <el-button type="default" size="small" class="inv-mgmt-excel-btn">导入Excel</el-button>
        </el-upload>
        <el-button type="default" size="small" class="inv-mgmt-excel-btn" @click="exportExcel">导出Excel</el-button>
        <a class="inv-mgmt-template-link" href="javascript:;" @click.prevent="handleDownloadTemplate">下载模板</a>
      </div>
      <el-button type="primary" size="small" class="inv-inout-card-header__cta" @click="dialogVisible = true">
        出入库填报
      </el-button>
    </div>

    <el-card shadow="never" class="employee-card">
      <el-form
        :inline="false"
        :model="filters"
        label-position="top"
        class="inventory-filter-form inventory-filter-form--stacked"
      >
        <div class="filter-row filter-row-1">
          <el-form-item label="使用区域：">
            <el-select v-model="filters.region" placeholder="全部" size="small" style="width: 150px;">
              <el-option label="全部" value="all" />
              <el-option v-for="r in regions" :key="r" :label="r" :value="r" />
            </el-select>
          </el-form-item>

          <el-form-item label="操作人：">
            <el-input
              v-model="filters.operator"
              placeholder="筛选列表展示用（可选）"
              size="small"
              clearable
              style="width: 180px;"
            />
          </el-form-item>

          <el-form-item label="关键词：">
            <el-input
              v-model="filters.keyword"
              placeholder="商品名称"
              size="small"
              clearable
              prefix-icon="el-icon-search"
              style="width: 220px;"
            />
          </el-form-item>
        </div>

        <div class="filter-actions">
          <el-button
            type="primary"
            size="mini"
            class="el-button el-button--primary el-button--mini"
            icon="el-icon-search"
            @click="search"
          >
            筛选
          </el-button>
          <el-button
            type="primary"
            size="mini"
            class="el-button el-button--primary el-button--mini"
            icon="el-icon-refresh"
            @click="reset"
          >
            重置
          </el-button>
        </div>
      </el-form>
    </el-card>

    <el-card shadow="never" class="employee-card" style="margin-top: 18px;">
      <div class="card-header" style="margin-bottom: 12px;">
        <div class="card-title">库存汇总列表</div>
      </div>

      <el-table
        :data="pagedSummary"
        border
        stripe
        style="width: 100%;"
        class="employee-table el-table el-table--border el-table--striped"
      >
        <el-table-column prop="productName" label="商品名称" min-width="160" />
        <el-table-column prop="usageArea" label="使用区域" min-width="120" class-name="inv-col-nowrap" />
        <el-table-column prop="currentStock" label="库存数量" min-width="100" />
        <el-table-column prop="unit" label="单位" min-width="80" />
        <el-table-column label="最低阈值" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.warningThreshold != null && scope.row.warningThreshold !== '' ? scope.row.warningThreshold : '—' }}
          </template>
        </el-table-column>
        <el-table-column prop="lastOperator" label="填报人" min-width="120" />
        <el-table-column prop="lastOperationTime" label="填报时间" min-width="170" />
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" class="btn-secondary" @click="openAdjustDialog(scope.row)">
              修改库存
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新增库存商品 -->
    <el-dialog
      title="添加库存商品"
      :visible.sync="createItemVisible"
      width="520px"
      append-to-body
      @closed="resetCreateForm"
    >
      <el-form :model="createForm" label-width="120px">
        <el-form-item label="商品名称" required>
          <el-input v-model="createForm.name" placeholder="必填" maxlength="80" show-word-limit />
        </el-form-item>
        <el-form-item label="使用区域" required>
          <el-select v-model="createForm.usageArea" placeholder="请选择" style="width: 100%;">
            <el-option v-for="r in regions" :key="r" :label="r" :value="r" />
          </el-select>
        </el-form-item>
        <el-form-item label="单位" required>
          <el-select v-model="createForm.unit" placeholder="请选择" filterable style="width: 100%;">
            <el-option v-for="u in units" :key="u" :label="u" :value="u" />
          </el-select>
        </el-form-item>
        <el-form-item label="初始库存数量" required>
          <el-input-number v-model="createForm.quantity" :min="0" :step="1" controls-position="right" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="最低库存阈值">
          <el-input-number v-model="createForm.minThreshold" :min="0" :step="1" controls-position="right" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="createForm.remark" type="textarea" :rows="2" placeholder="选填" />
        </el-form-item>
        <el-form-item label="操作人">
          <el-input v-model="createForm.operator" placeholder="默认当前用户" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-secondary" @click="createItemVisible = false">取消</el-button>
        <el-button class="btn-primary" :loading="createSaving" @click="submitCreateItem">保存</el-button>
      </span>
    </el-dialog>

    <!-- 修改库存 -->
    <el-dialog
      title="修改库存"
      :visible.sync="adjustVisible"
      width="480px"
      append-to-body
      @closed="adjustRow = null"
    >
      <el-form v-if="adjustRow" label-width="120px">
        <el-form-item label="商品名称">
          <el-input :value="adjustRow.productName" disabled />
        </el-form-item>
        <el-form-item label="使用区域">
          <el-input :value="adjustRow.usageArea" disabled />
        </el-form-item>
        <el-form-item label="当前库存">
          <el-input :value="String(adjustRow.currentStock)" disabled />
        </el-form-item>
        <el-form-item label="调整后库存" required>
          <el-input-number v-model="adjustForm.newQty" :min="0" :step="1" controls-position="right" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="调整原因">
          <el-select v-model="adjustForm.reason" placeholder="选填" style="width: 100%;" clearable>
            <el-option label="盘点修正" value="盘点修正" />
            <el-option label="损耗" value="损耗" />
            <el-option label="其他" value="其他" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="adjustForm.remark" type="textarea" :rows="2" placeholder="选填" />
        </el-form-item>
        <el-form-item label="操作人">
          <el-input v-model="adjustForm.operator" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-secondary" @click="adjustVisible = false">取消</el-button>
        <el-button class="btn-primary" :loading="adjustSaving" @click="submitAdjust">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="出入库填报"
      :visible.sync="dialogVisible"
      width="600px"
      custom-class="inventory-inout-dialog"
      center
    >
      <el-tabs v-model="activeTab" class="lvyun-tabs">
        <el-tab-pane label="入库填报" name="in">
          <div class="form-wrap">
            <el-form :model="inboundForm" label-width="100px" :inline="false">
              <el-form-item label="商品：">
                <el-select
                  v-model="inboundForm.itemId"
                  placeholder="请选择门店库存商品"
                  filterable
                  clearable
                  style="width: 100%;"
                  @change="handleInboundStockRefresh"
                >
                  <el-option
                    v-for="p in products"
                    :key="p.id"
                    :label="productOptionLabel(p)"
                    :value="p.id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-if="selectedInboundProduct" label="">
                <div class="stock-preview">使用区域：<span class="stock-value">{{ selectedInboundProduct.usageArea }}</span> · 单位：{{ selectedInboundProduct.unit }}</div>
              </el-form-item>

              <el-form-item label="入库数量：">
                <el-input-number
                  v-model="inboundForm.quantity"
                  :min="1"
                  controls-position="right"
                />
                <div class="stock-preview">
                  当前库存：<span class="stock-value">{{ inboundCurrentStock }}</span>
                </div>
              </el-form-item>

              <el-form-item label="操作人：">
                <el-input v-model="inboundForm.operator" placeholder="请输入操作人" />
              </el-form-item>

              <el-form-item label="备注：">
                <el-input type="textarea" :rows="3" v-model="inboundForm.remark" placeholder="可选" />
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <el-tab-pane label="出库填报" name="out">
          <div class="form-wrap">
            <el-form :model="outboundForm" label-width="100px" :inline="false">
              <el-form-item label="商品：">
                <el-select
                  v-model="outboundForm.itemId"
                  placeholder="请选择门店库存商品"
                  filterable
                  clearable
                  style="width: 100%;"
                  @change="handleOutboundStockRefresh"
                >
                  <el-option
                    v-for="p in products"
                    :key="p.id"
                    :label="productOptionLabel(p)"
                    :value="p.id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-if="selectedOutboundProduct" label="">
                <div class="stock-preview">使用区域：<span class="stock-value">{{ selectedOutboundProduct.usageArea }}</span> · 单位：{{ selectedOutboundProduct.unit }}</div>
              </el-form-item>

              <el-form-item label="出库数量：">
                <el-input-number
                  v-model="outboundForm.quantity"
                  :min="1"
                  controls-position="right"
                />
                <div class="stock-preview stock-preview-warn">
                  当前库存：<span class="stock-value">{{ outboundCurrentStock }}</span>
                  <span v-if="isOutOverStock" class="stock-warning-extra">（库存不足）</span>
                </div>
              </el-form-item>

              <el-form-item label="操作人：">
                <el-input v-model="outboundForm.operator" placeholder="请输入操作人" />
              </el-form-item>

              <el-form-item label="备注：">
                <el-input type="textarea" :rows="3" v-model="outboundForm.remark" placeholder="可选" />
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button class="btn-secondary" @click="resetCurrent">取消</el-button>
        <el-button class="btn-primary" :disabled="isConfirmDisabled" @click="submitCurrent">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchInventoryRegions,
  fetchInventoryUnits,
  fetchInventoryRows,
  fetchInventoryProducts,
  fetchCurrentStock,
  submitInbound,
  submitOutbound,
  createInventoryItem,
  adjustInventoryItem,
  downloadInventoryTemplate,
  exportInventoryExcel,
  importInventoryExcel
} from '../api/inventory'
import { getUserInfo } from '../utils/auth'
import { onInventoryChanged, notifyInventoryChanged } from '../utils/inventorySync'

const SYNC_SOURCE = 'InventoryInOutReport'

export default {
  name: 'InventoryInOutReport',
  data() {
    const userInfo = getUserInfo()
    const defaultOperator = userInfo && userInfo.username ? userInfo.username : '管理员'
    return {
      _unsubInventorySync: null,
      activeTab: 'in',
      dialogVisible: false,
      advancedOpen: true,
      defaultOperator,

      regions: [],
      units: [],
      products: [],

      filters: {
        region: 'all',
        operator: '',
        keyword: ''
      },

      summaryRowsAll: [],
      pagedSummary: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,

      createItemVisible: false,
      createSaving: false,
      createForm: {
        name: '',
        usageArea: '',
        unit: '',
        quantity: 0,
        minThreshold: undefined,
        remark: '',
        operator: defaultOperator
      },

      adjustVisible: false,
      adjustSaving: false,
      adjustRow: null,
      adjustForm: {
        newQty: 0,
        reason: '盘点修正',
        remark: '',
        operator: defaultOperator
      },

      inboundForm: {
        itemId: '',
        quantity: 1,
        operator: defaultOperator,
        remark: ''
      },
      outboundForm: {
        itemId: '',
        quantity: 1,
        operator: defaultOperator,
        remark: ''
      },

      inboundCurrentStock: 0,
      outboundCurrentStock: 0
    }
  },
  computed: {
    selectedInboundProduct() {
      return (this.products || []).find(p => p.id === this.inboundForm.itemId) || null
    },
    selectedOutboundProduct() {
      return (this.products || []).find(p => p.id === this.outboundForm.itemId) || null
    },
    isOutOverStock() {
      if (this.activeTab !== 'out') return false
      const q = Number(this.outboundForm.quantity)
      if (!this.outboundForm.itemId) return false
      if (!Number.isFinite(q) || q <= 0) return false
      return q > this.outboundCurrentStock
    },
    isConfirmDisabled() {
      return this.activeTab === 'out' && this.isOutOverStock
    }
  },
  mounted() {
    this.init()
    this._unsubInventorySync = onInventoryChanged((e) => {
      const src = e && e.detail && e.detail.source
      if (src === SYNC_SOURCE) return
      this.refreshInventoryFromSync()
    })
  },
  beforeDestroy() {
    if (this._unsubInventorySync) {
      this._unsubInventorySync()
      this._unsubInventorySync = null
    }
  },
  methods: {
    async refreshInventoryFromSync() {
      try {
        await this.reloadProductsAndForms()
        await this.fetchSummary()
      } catch (e) {}
    },
    productOptionLabel(p) {
      if (!p) return ''
      return `${p.name}（${p.usageArea || ''}）`
    },

    async init() {
      const regionsResp = await fetchInventoryRegions()
      this.regions = regionsResp && regionsResp.data ? regionsResp.data : []

      const unitsResp = await fetchInventoryUnits()
      this.units = unitsResp && unitsResp.data ? unitsResp.data : []

      await this.reloadProductsAndForms()
      await this.fetchSummary()
    },

    async reloadProductsAndForms() {
      const productsResp = await fetchInventoryProducts()
      this.products = productsResp && productsResp.data ? productsResp.data : []
      if (this.products.length) {
        if (!this.inboundForm.itemId || !this.products.some(p => p.id === this.inboundForm.itemId)) {
          this.inboundForm.itemId = this.products[0].id
        }
        if (!this.outboundForm.itemId || !this.products.some(p => p.id === this.outboundForm.itemId)) {
          this.outboundForm.itemId = this.products[0].id
        }
      } else {
        this.inboundForm.itemId = ''
        this.outboundForm.itemId = ''
      }
      await this.handleInboundStockRefresh()
      await this.handleOutboundStockRefresh()
    },

    openCreateItemDialog() {
      this.createForm = {
        name: '',
        usageArea: this.regions[0] || '',
        unit: (this.units && this.units[0]) || '个',
        quantity: 0,
        minThreshold: undefined,
        remark: '',
        operator: this.defaultOperator
      }
      this.createItemVisible = true
    },

    resetCreateForm() {
      this.createSaving = false
    },

    async submitCreateItem() {
      const payload = {
        name: this.createForm.name,
        usageArea: this.createForm.usageArea,
        unit: this.createForm.unit,
        quantity: this.createForm.quantity,
        remark: this.createForm.remark,
        operator: this.createForm.operator || this.defaultOperator
      }
      if (this.createForm.minThreshold !== undefined && this.createForm.minThreshold !== null && this.createForm.minThreshold !== '') {
        payload.minThreshold = this.createForm.minThreshold
      }
      this.createSaving = true
      try {
        const resp = await createInventoryItem(payload)
        if (resp && (resp.code === 200 || resp.code === 201)) {
          this.$message.success(resp.message || '保存成功')
          this.createItemVisible = false
          await this.reloadProductsAndForms()
          await this.fetchSummary()
          notifyInventoryChanged(SYNC_SOURCE)
        } else {
          this.$message.error((resp && resp.message) || '保存失败')
        }
      } catch (e) {
        const msg = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : '保存失败'
        this.$message.error(msg)
      } finally {
        this.createSaving = false
      }
    },

    openAdjustDialog(row) {
      this.adjustRow = row
      this.adjustForm = {
        newQty: Number(row.currentStock) || 0,
        reason: '盘点修正',
        remark: '',
        operator: this.defaultOperator
      }
      this.adjustVisible = true
    },

    async submitAdjust() {
      if (!this.adjustRow || !this.adjustRow.itemId) return
      const nq = Math.floor(Number(this.adjustForm.newQty))
      if (!Number.isFinite(nq) || nq < 0) {
        this.$message.warning('调整后库存须为非负整数')
        return
      }
      this.adjustSaving = true
      try {
        const resp = await adjustInventoryItem(this.adjustRow.itemId, {
          newQty: nq,
          reason: this.adjustForm.reason || '其他',
          remark: this.adjustForm.remark,
          operator: this.adjustForm.operator || this.defaultOperator
        })
        if (resp && resp.code === 200) {
          this.$message.success(resp.message || '已更新')
          this.adjustVisible = false
          await this.reloadProductsAndForms()
          await this.fetchSummary()
          notifyInventoryChanged(SYNC_SOURCE)
        } else {
          this.$message.error((resp && resp.message) || '更新失败')
        }
      } catch (e) {
        const msg = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : '更新失败'
        this.$message.error(msg)
      } finally {
        this.adjustSaving = false
      }
    },

    applyPagination() {
      const startIdx = (this.currentPage - 1) * this.pageSize
      const endIdx = startIdx + this.pageSize
      this.pagedSummary = (this.summaryRowsAll || []).slice(startIdx, endIdx)
    },

    async fetchSummary() {
      try {
        const rowsResp = await fetchInventoryRows({
          region: this.filters.region,
          category: 'all',
          keyword: this.filters.keyword
        })
        let rows = rowsResp && rowsResp.code === 200 && Array.isArray(rowsResp.data) ? rowsResp.data : []
        const op = (this.filters.operator || '').trim()
        if (op) {
          rows = rows.filter(r => (r.lastOperator || '').includes(op))
        }
        this.summaryRowsAll = rows
        this.currentPage = 1
        this.total = this.summaryRowsAll.length
        this.applyPagination()
      } catch (e) {
        this.summaryRowsAll = []
        this.total = 0
        this.pagedSummary = []
      }
    },

    async search() {
      await this.fetchSummary()
    },

    async reset() {
      this.filters = {
        region: 'all',
        operator: '',
        keyword: ''
      }
      await this.fetchSummary()
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.applyPagination()
    },

    async handleDownloadTemplate() {
      try {
        await downloadInventoryTemplate()
      } catch (e) {
        this.$message.error('模板下载失败')
      }
    },

    async exportExcel() {
      try {
        await exportInventoryExcel({
          region: this.filters.region,
          keyword: this.filters.keyword
        })
      } catch (e) {
        this.$message.error('导出失败')
      }
    },

    formatImportErrors(result) {
      const errs = result && result.errors ? result.errors : []
      if (!errs.length) return ''
      return errs.slice(0, 12).map((x) => `第 ${x.line} 行：${x.message}`).join('\n')
    },

    async handleImportExcel(file) {
      try {
        const operator = this.defaultOperator || '管理员'
        const resp = await importInventoryExcel(file, operator)
        if (resp && resp.code === 200) {
          const extra = this.formatImportErrors(resp.data)
          if (extra) {
            this.$alert(`${resp.message || '导入完成'}\n\n${extra}`, '导入结果', { type: 'warning' })
          } else {
            this.$message.success(resp.message || '导入成功')
          }
          await this.reloadProductsAndForms()
          await this.fetchSummary()
          notifyInventoryChanged(SYNC_SOURCE)
        } else if (resp && resp.code === 400 && resp.data && resp.data.errors) {
          const msg = this.formatImportErrors(resp.data) || resp.message || '导入失败'
          this.$alert(msg, '导入校验失败', { type: 'error' })
        } else {
          this.$message.error((resp && resp.message) || '导入失败')
        }
      } catch (e) {
        const data = e && e.response && e.response.data
        if (data && data.data && data.data.errors) {
          this.$alert(this.formatImportErrors(data.data) || data.message, '导入校验失败', { type: 'error' })
        } else {
          const msg = data && data.message ? data.message : '导入失败'
          this.$message.error(msg)
        }
      }
      return false
    },

    async refreshStockFor(formType) {
      const target = formType === 'in' ? this.inboundForm : this.outboundForm
      const itemId = target.itemId
      if (!itemId) {
        if (formType === 'in') this.inboundCurrentStock = 0
        else this.outboundCurrentStock = 0
        return 0
      }
      const resp = await fetchCurrentStock(itemId)
      const cur = resp && resp.code === 200 && resp.data && Number.isFinite(Number(resp.data.currentStock))
        ? Number(resp.data.currentStock)
        : 0
      if (formType === 'in') this.inboundCurrentStock = cur
      else this.outboundCurrentStock = cur
      return cur
    },

    async handleInboundStockRefresh() {
      return this.refreshStockFor('in')
    },
    async handleOutboundStockRefresh() {
      return this.refreshStockFor('out')
    },

    resetInbound() {
      this.inboundForm.quantity = 1
      this.inboundForm.remark = ''
      this.inboundForm.operator = this.defaultOperator || '管理员'
      this.handleInboundStockRefresh()
    },
    resetOutbound() {
      this.outboundForm.quantity = 1
      this.outboundForm.remark = ''
      this.outboundForm.operator = this.defaultOperator || '管理员'
      this.handleOutboundStockRefresh()
    },

    resetCurrent() {
      if (this.activeTab === 'in') return this.resetInbound()
      return this.resetOutbound()
    },

    async submitInbound() {
      if (!this.inboundForm.itemId) {
        this.$message.warning('请先选择商品')
        return
      }
      const quantity = Number(this.inboundForm.quantity)
      if (!Number.isFinite(quantity) || quantity <= 0) {
        this.$message.warning('入库数量不合法')
        return
      }
      await this.handleInboundStockRefresh()
      try {
        const resp = await submitInbound({
          itemId: this.inboundForm.itemId,
          quantity,
          operator: this.inboundForm.operator,
          remark: this.inboundForm.remark
        })
        if (resp && resp.code === 200) {
          this.$message.success('入库提交成功')
          this.dialogVisible = false
          await this.reloadProductsAndForms()
          await this.fetchSummary()
          notifyInventoryChanged(SYNC_SOURCE)
        } else {
          this.$message.error(resp && resp.message ? resp.message : '入库提交失败')
        }
      } catch (e) {
        const msg = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : '入库提交失败'
        this.$message.error(msg)
      }
    },

    async submitOutbound() {
      if (!this.outboundForm.itemId) {
        this.$message.warning('请先选择商品')
        return
      }
      const quantity = Number(this.outboundForm.quantity)
      if (!Number.isFinite(quantity) || quantity <= 0) {
        this.$message.warning('出库数量不合法')
        return
      }
      const cur = await this.handleOutboundStockRefresh()
      if (quantity > cur) {
        this.$alert(`库存不足，当前库存：${cur}`, '提示', { type: 'warning' })
        return
      }
      try {
        const resp = await submitOutbound({
          itemId: this.outboundForm.itemId,
          quantity,
          operator: this.outboundForm.operator,
          remark: this.outboundForm.remark
        })
        if (resp && resp.code === 200) {
          this.$message.success('出库提交成功')
          this.dialogVisible = false
          await this.reloadProductsAndForms()
          await this.fetchSummary()
          notifyInventoryChanged(SYNC_SOURCE)
        } else {
          this.$message.error(resp && resp.message ? resp.message : '出库提交失败')
        }
      } catch (e) {
        const msg = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : '出库提交失败'
        this.$message.error(msg)
      }
    },

    async submitCurrent() {
      if (this.activeTab === 'in') return this.submitInbound()
      return this.submitOutbound()
    }
  }
}
</script>

<style scoped>
.employee-management {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.inv-inout-card-header {
  flex-wrap: wrap;
}

.inv-inout-card-header__center {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 200px;
}

.inv-inout-card-header__cta {
  flex-shrink: 0;
}

.filter-topbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.inventory-filter-form {
  width: 100%;
  overflow-x: auto;
}

.filter-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
}

.filter-row-1 {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(150px, 1fr));
  align-items: start;
  column-gap: 20px;
}

.filter-row-2 {
  width: 100%;
  margin-top: 16px;
}

.inventory-filter-form ::v-deep .el-form-item {
  margin-bottom: 0;
}

.inventory-filter-form.inventory-filter-form--stacked ::v-deep .el-form-item {
  margin-bottom: 12px;
}

.inventory-filter-form ::v-deep .el-form-item__label {
  white-space: nowrap;
  line-height: 1.3;
  padding-bottom: 4px;
}

.inventory-filter-form ::v-deep .el-form-item__content {
  margin-left: 0 !important;
}

.filter-actions {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.pagination {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}

.form-wrap {
  padding: 6px 0;
}

.inventory-inout-dialog ::v-deep .el-dialog {
  border-radius: 12px;
  box-shadow: var(--shadow-soft);
  overflow: hidden;
}

.inventory-inout-dialog ::v-deep .el-dialog__header {
  padding: 18px 20px;
}

.inventory-inout-dialog ::v-deep .el-dialog__body {
  padding: 24px 20px 10px;
}

.inventory-inout-dialog ::v-deep .el-form-item {
  margin-bottom: 16px;
}

.inventory-inout-dialog ::v-deep .el-form-item__label {
  text-align: left;
}

.inventory-inout-dialog ::v-deep .el-form-item__content {
  width: 100%;
}

.inventory-inout-dialog ::v-deep .el-input {
  width: 100%;
}

.inventory-inout-dialog ::v-deep .el-input__inner {
  height: 44px;
  line-height: 44px;
}

.inventory-inout-dialog ::v-deep .el-input-number__decrease,
.inventory-inout-dialog ::v-deep .el-input-number__increase {
  height: 44px;
}

.inventory-inout-dialog ::v-deep .el-select .el-input__inner {
  height: 44px;
  line-height: 44px;
}

.stock-warning-extra {
  margin-left: 8px;
  font-size: 12px;
  font-weight: 600;
}

.stock-preview {
  margin-top: 8px;
  font-size: 12px;
}

.stock-preview-warn {
  color: #f53f3f;
}

.stock-value {
  font-weight: 800;
  color: inherit;
}

.product-table {
  width: 100%;
}

.image-slot {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #c0c4cc;
  border-radius: 6px;
}

@media (max-width: 900px) {
  /* no-op */
}
</style>
